import * as React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import AddBenefitCategoryBtn from './AddBenefitCategoryBtn';
import { useGetAllBenefitQuery } from '@/store/benefitApi';
import { useGetBenefitCategoryQuery } from '@/store/benefitCategoryApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import FilterDropdown from './FilterDropdown';
import BenefitFormDialog from './BenefitFormDialog';
import useSearchBenefit from '@/hooks/useSearchBenefit';
import BenefitCategories from './BenefitCategories';
import RecentBenefits from './RecentBenefits';
import BenefitFilterSection from './BenefitFilterSection';

const AdminBenefitDashboard = () => {
  const { user } = useSelector((state: RootState) => state.user);
  const { data: allBenefits } = useGetAllBenefitQuery(user?.token);
  const { data: allLedger } = useGetBenefitCategoryQuery(user?.token);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [filteredBenefits, setFilteredBenefits] = React.useState('');
  const [isOpen, setIsOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const { filterBySearchTerm } = useSearchBenefit(
    allBenefits || [],
    searchTerm,
    filteredBenefits
  );

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
          <h1 className="text-2xl font-bold text-foreground mb-4 sm:mb-0">
            Benefits & Inflows Management
          </h1>
          <div className="flex flex-wrap gap-3">
            <AddBenefitCategoryBtn />
            <BenefitFormDialog
              open={isOpen}
              setOpen={setIsOpen}
              editBenefit={editData}
              setEdit={setEditData}
            />
          </div>
        </div>

        {/* Filter Section */}
        <BenefitFilterSection
          filterBySearchTerm={filterBySearchTerm}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>

      {/* Benefit Cards Grid */}
      <BenefitCategories allBenefits={allBenefits || []} allLedger={allLedger || []} />

      <Card className="mb-8">
        <CardContent className="p-6">
          <div className="md:flex justify-between items-center mb-6">
            <h2 className="text-xl font-semibold">Recent Inflows</h2>

            <FilterDropdown
              categories={allLedger || []}
              setFilter={setFilteredBenefits}
            />
          </div>
          <RecentBenefits
            filterBySearchTerm={filterBySearchTerm}
            setEditData={setEditData}
            setIsOpen={setIsOpen}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminBenefitDashboard;
